import List from "@/components/list";

const Table = args => {
  const { listeners } = args;
  const auditDetail = listeners["auditDetail"] || function () { };

  const Deal = ({ props: { vo } }) => {
    const curItem = vo.row;
    let dealConf = [];

    dealConf.push(["icon-audit-detail", "审核详情", () => auditDetail(curItem), ""])
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const AccountTableConfig = [
    {
      label: "姓名",
      prop: "userName",
      width: "110"
    },
    {
      label: "工作单位",
      prop: "deptName",
      width: "150",
      showOverflowTooltip: true,
    },
    {
      label: "单位及职务",
      prop: "unitPosition",
      width: "150"
    },
    {
      label: "学习名称",
      prop: "lectureName",
      width: "120"
    },
    {
      label: "学习时间",
      prop: "learnDate",
      width: "120",
    },
    {
      label: "学时",
      prop: "lectureHours",
      width: "80"
    },
    {
      label: "学习单位",
      prop: "organizer",
      width: "150",
      showOverflowTooltip: true,
    },
    {
      label: "学习地点",
      prop: "lecturePlace",
      width: "150",
      showOverflowTooltip: true,
    },
    {
      label: "审核状态",
      prop: "auditStatusStr",
      width: "90",
      // render: vo => <AuditStatus vo={vo} />
    },
    {
      label: "申报时间",
      prop: "createDate",
      width: "160"
    },
    {
      label: "操作",
      width: "60",
      render: vo => <Deal vo={vo} />
    }
  ];

  return (
    <div>
      <List
        {...args}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
